import React, { FC, useEffect } from "react"
import { Loading } from "../../views/Loading"
import { CarrotQueryParam } from "utils/CarrotUrls"

const SignatureCompletedContainer: FC = () => {
  useEffect(() => {
    const separator = window.top.location.href.indexOf("?") === -1 ? "?" : "&"
    window.top.location.href = window.top.location.href + separator + `${CarrotQueryParam.Signed}=true`
  }, [])

  return <Loading />
}

export { SignatureCompletedContainer }
